// extracted by mini-css-extract-plugin
var _1 = "Badge-module__animateUploadProgressBarWidth--iIlyq";
var _2 = "Badge-module__animatedBackground--E0ff5";
var _3 = "Badge-module__badge--Y3gBz";
var _4 = "Badge-module__badgeButton--wpWfn";
var _5 = "Badge-module__blue--IE_us";
var _6 = "Badge-module__content--MhInn";
var _7 = "Badge-module__defaultNoBorder--LtZ8z";
var _8 = "Badge-module__gray--hPrtP";
var _9 = "Badge-module__green--x_Uwi";
var _a = "Badge-module__hasIcon--p12TY";
var _b = "Badge-module__icon--glWaI";
var _c = "Badge-module__inline--QWYv1";
var _d = "Badge-module__pink--tR8DP";
var _e = "Badge-module__red--g_D1a";
var _f = "Badge-module__rust--UdrTV";
var _10 = "Badge-module__yellow--Qq7ri";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "badgeButton", _5 as "blue", _6 as "content", _7 as "defaultNoBorder", _8 as "gray", _9 as "green", _a as "hasIcon", _b as "icon", _c as "inline", _d as "pink", _e as "red", _f as "rust", _10 as "yellow" }
